export default {
  typePlacehold: 'please type app name or key words'

};
